// utils/authRepository.ts
import type { NitroFetchRequest, $Fetch } from 'nitropack'
import type { AuthVerifyResponse } from '~/types/types'

export const authRepository = () => {
  const { $api } = useNuxtApp()
  return {

    /**
     * إرسال رقم الجوال لتسجيل الدخول وإرجاع `code_token`.
     */
    async login(mobile: string): Promise<{ code_token: string; phone_number: string; email?: string }> {
      const response = await $api<{ data: { code_token: string; phone_number: string; email?: string } }>(
        '/login',
        {
          method: 'POST',
          body: { phone_number: mobile },
        }
      )
      return response.data
    },
    /**
     * إرسال رقم الجوال لتسجيل الدخول وإرجاع `code_token`.
     */
    async resendCodeForProfile(mobile: string): Promise<{ code_token: string; phone_number: string; email?: string }> {
      const response = await $api<{ data: { code_token: string; phone_number: string; email?: string } }>(
        '/profile/resend',
        {
          method: 'POST',
          body: { phone_number: mobile },
        }
      )
      return response.data
    },

    /**
     * تأكيد رمز التحقق المرسل إلى الجوال.
     */
    async verifyCode(code_token: string, code: string): Promise<{ access_token: string }> {
      const device_name = navigator.userAgent
      const response = await $api<{ data: { access_token: string } }>('/verify', {
        method: 'POST',
        body: { code_token, device_name, code },
      })
      return response.data
    },

    /**
     * تحديث اسم المستخدم.
     */
    async profileConfirmation(code_token: string, code: string): Promise<{ access_token: string }> {
      const response = await $api<{ data: { access_token: string } }>('/profile-confirmation', {
        method: 'PUT',
        body: { code_token, code },
      })
      return response.data
    },
    /**
     * تحديث اسم المستخدم.
     */
    async setName(name: string): Promise<{ access_token: string }> {
      const response = await $api<{ data: { access_token: string } }>('/enter-name', {
        method: 'PUT',
        body: { name },
      })
      return response.data
    },
    /**
     * تحديث يبانات المستخدم.
     */
    async updateProfile(formData: FormData): Promise<{ response: { status: boolean; message: string } }> {
      const response = await $api<{ status: boolean; message: string }>(`/profile`, {
        method: 'post',
        body: formData,
      })

      return response
    },

    /**
     * استرجاع بروفايل المستخدم.
     */
    async getProfile(): Promise<AuthVerifyResponse> {
      const response = await $api<AuthVerifyResponse>('/profile', {
        method: 'GET',
      })
      return response
    },
  }
}
